import IconInsurance from './IconInsurance'
import IconEnergy from './IconEnergy'
import IconTelecom from './IconTelecom'
import { OptionIconWrapper } from './styled-components'

// eslint-disable-next-line react/prop-types
const OptionIconComponent = ({ iconName, alt }) => {
  const icons = {
    energy: () => <IconEnergy size={45} color='currentColor' />,
    telecom: () => <IconTelecom size={45} color='currentColor' />,
    insurance: () => <IconInsurance size={45} color='currentColor' />,
  }
  const IconComponent = icons[iconName] ? icons[iconName] : null

  if (!IconComponent) {
    return null
  }

  return (
    <OptionIconWrapper className='option-icon' title={alt}>
      <IconComponent />
    </OptionIconWrapper>
  )
}

export default OptionIconComponent
